import type { EmHomeCardMedium, EmHomeCardSmall } from './EMHome.types';

export function getCardImage(showDesktopImage: boolean, card: EmHomeCardMedium | EmHomeCardSmall) {
  const hasDesktopImage = !!card.front_side_image_desktop?.filename;
  const hasMobileImage = !!card.front_side_image_mobile?.filename;
  if (showDesktopImage) {
    return hasDesktopImage ? card.front_side_image_desktop : hasMobileImage ? card.front_side_image_mobile : undefined;
  }
  return hasMobileImage ? card.front_side_image_mobile : hasDesktopImage ? card.front_side_image_desktop : undefined;
}

export function getCardVideo(showDesktopVideo: boolean, card: EmHomeCardMedium | EmHomeCardSmall) {
  const hasDesktopVideo = !!card.front_side_video_desktop?.filename;
  const hasMobileVideo = !!card.front_side_video_mobile?.filename;
  if (showDesktopVideo) {
    return hasDesktopVideo ? card.front_side_video_desktop : hasMobileVideo ? card.front_side_video_mobile : undefined;
  }
  return hasMobileVideo ? card.front_side_video_mobile : hasDesktopVideo ? card.front_side_video_desktop : undefined;
}
